<template>
	<Container class="root2" ref='root2' @scrollEvent='handleScroll'>
		<template v-if='scrollTop>offsetTop'>
			<Affix :offset-top="offsetTop-2">
				<div class='breadcrumbPage'>
					<Breadcrumb class='breadcrumb'>
						<BreadcrumbItem to="/order/product">
							<b class='detail-link'>返回(Back)</b>
						</BreadcrumbItem>
						<!-- <BreadcrumbItem>{{productType}}</BreadcrumbItem> -->
						<BreadcrumbItem>{{product.name}}</BreadcrumbItem>
					</Breadcrumb>
				</div>
			</Affix>
		</template>
		<template v-else>
			<div class='breadcrumbPage'>
				<Breadcrumb class='breadcrumb'>
					<BreadcrumbItem  >
						<b @click="back" class='detail-link'>返回(Back)</b>
					</BreadcrumbItem>
					<!-- <BreadcrumbItem>{{productType}}</BreadcrumbItem> -->
					<BreadcrumbItem>{{product.name}}</BreadcrumbItem>
				</Breadcrumb>
			</div>
		</template>
		<div class="detailPage">
			<div class='load' v-show='showLoading'>
				<loading />
			</div>
			<template v-if='!showLoading'>

				<Row class='product'>
					<Col :lg='10' style="position: relative;">
					<template v-if='imageList.length==1'>
						<img  src="@/assets/defaultImg.png" v-real-img="image_path" style="margin: auto;" class="img-responsive">
					</template>
					<template v-else>
						<Carousel v-if='imageList[0]' v-model="noticeIndex" :autoplay-speed='5000' :arrow="'hover'" :autoplay='autoplay'>
							<CarouselItem v-for="item in imageList" :key="item.src">
								<div class='carousellayou' @click="autoNo(item)">
									<template v-if='item.type=="video"'>
										<template v-if='item.src.indexOf("dohwg.cn") != -1' >
											<Video 
												class='video' 
												:src='item.src'
												:pic='item.icon'
												@onPlayEnded='autoplay = true'
												@onPause='autoplay = true'
												@onPlaying='autoplay = false'
										/>
										</template>
										<template v-else>
											<div class='videoMask'>
												<img src='@/assets/order/bplay.png'  >
											</div>
											<img class='product_img' src="@/assets/defaultImg.png" v-real-img="item.icon"  />
										</template>
									</template>
									<template v-else>
										<img  class='product_img' src="@/assets/defaultImg.png"  v-real-img="item.icon"  />
									</template>
								</div>
							</CarouselItem>
						</Carousel>
					</template>
					<!-- <img :src="image_path" style="margin: auto;" class="img-responsive"> -->
					</Col>
					<Col :lg='14' class='right'>
					<p class="pro-name" v-if='product.specproducts&&product.specproducts.length>0'>{{product.specproducts[0].name}}<br>{{product.specproducts[0].name_en}}</p>
					<p class="sku">套裝編號SKU：{{product.sku}}
						<!-- <template v-if='product.specproducts&&product.specproducts[0]'>
							<span style="margin-left: 20px" v-if="product.specproducts[0].pt>0 && $parent.isOriginalPrice==false">PT:{{product.specproducts[0].pt}}</span>
						</template> -->
					</p>
					<section class="info" v-if='product.specproducts&&product.specproducts[0]'>
						<span class="info-pv">PV點數:{{product.specproducts[0].pv}}</span>
						<!-- <span class="info-ge">{{product.specproducts[0].specs[0].name}}：{{product.specproducts[0].specs[0].value}}</span> -->
						<!-- <span class="info-pt" v-if="product.specproducts[0].pt>0">PT:{{product.specproducts[0].pt}}</span> -->
					</section>
					<section class="activityflag" v-if='showActivity(product)'>
						<span v-if='product.is_hot == 1' class="hot">熱銷<b>(Hot)</b></span>
						<span v-if='product.is_new == 1' class="hot">新品<b>(New)</b></span>
						<span v-if='product.is_promotion == 1' class="hot">促銷<b>(Promotion)</b></span>
					</section>
					<div class='price'>
						<span style="font-size: 16px;color: #515A6E;">會員價 Member $P:  </span>
						<template v-if='product.specproducts&&product.specproducts[0]'>
							HK${{$parent.isPVOriginalPrice? product.specproducts[0].original_price : product.specproducts[0].price}}
						</template>
					</div>
					<div class='short-description' v-if='isdescription' v-html="description"></div>
					<div class="show_nostock" v-if='$parent.noStockText(product)' v-html="$parent.noStockText(product)"></div>
					<buyCart v-else v-model="product.num" :disabled='limit(product)' :iscart='1' placement='bottom-end' :product="product" @showSurveyfun='$parent.showSurveyfun' @showPromoCode='$parent.showPromoCode' @showTips='$parent.showTips'></buyCart>

					<!-- <p class="price" v-if='product.specproducts&&product.specproducts[0]'>HK${{$parent.isPVOriginalPrice? product.specproducts[0].original_price : product.specproducts[0].price}}</p> -->

					<div class="submit" v-if='false'>
						<Button type='primary' @click='back' size='large'>返回(back)</Button>
					</div>
					</Col>
				</Row>
				<p class="intro-title">産品詳細說明(Description)</p>
				<Row class='detail'>
					<Col span="24">
					<Table class='no_mobile' style='margin-bottom: 10px;' :columns="columns1" border stripe :data="PriceList"></Table>
					<div class='xs-cells y_mobile' v-for='order in PriceList' style='margin-bottom: 10px;'>
						<Row class='xs-cells-item' style='margin-top: 0.2rem;'>
							<Col span='12'>套裝編號SKU(Product Sku)</Col>
							<Col span='12' style='text-align: center;'>{{order.sku}}</Col>
						</Row>
						<!-- <Row class='xs-cells-item'>
							<Col span='12'>規格(Specification)</Col>
							<Col span='12' style='text-align: center;'>{{order.specification}}</Col>
						</Row> -->
						<!-- <Row class='xs-cells-item'>
							<Col span='12'>零售價(Retail Price)</Col>
							<Col span='12' style='text-align: center;'>{{order.original_price}}</Col>
						</Row> -->
						<Row class='xs-cells-item'>
							<Col span='12'>會員價(Member $P)</Col>
							<Col span='12' style='text-align: center;'>{{order.price}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>點數(Points)</Col>
							<Col span='12' style='text-align: center;'>{{order.pv}}</Col>
						</Row>

					</div>
					</Col>
					<!-- <Col span='24' v-if='isdescription' v-html='description'>
					</Col> -->
				</Row>
				<!-- 産品列錶 -->
				<template v-if='relatedList[0]'>
					<p class="intro-title">搭配推薦</p>
					<div class='m-result'>
						<ul>
							<template v-for='item in relatedList'>
								<ProductCell  :product='item' :key="item.sku" :isRead='true' :goodsWidth='goodsWidth' />
							</template>
						</ul>
					</div>
				</template>

				<div class="fordetail" v-html="detail_description"></div>
			</template>
		</div>
		<Modal v-model="showActivities" width="800" title="視頻播放" :mask-closable="false">
			<div class='shipping-mian'>
				<iframe :src="showVideoUrl" frameborder="0" allowfullscreen="allowfullscreen" webkitallowfullscreen="true" mozallowfullscreen="true" :style="{height:350+'px',width:'100%'}"></iframe>
			</div>
			<div slot="footer">
				<!-- <Button size="large" @click="cancel">取消(cancel)</Button>
            <Button type="primary" size="large"  @click="confirm">確認(confirm)</Button> -->
			</div>
		</Modal>
	</Container>
</template>

<script>
import loading from "@/components/order/loading";
import buyCart from "@/components/order/buyCart";
import ProductCell from "@/components/order/ProductCell";
import Video from '@/components/common/Video'
import {
	cartInfoMethods,
	userInfoOrderMethods
} from "@/components/common/mixin";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
	data() {
		return {
			autoplay:true,
			scrollTop: 0,
			product: {},
			showLoading: true,

			description: "",
			detail_description: "",
			image_path: null,
			PriceList: [],
			imageList: [],
			relatedList: [],

			showActivities: false,
			noticeIndex: 0,
			showVideoUrl: null,
			offsetTop:0,
			columns1: [
				{
					key: "sku",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "産品編號"),
							h("div", null, "Product Sku")
						]);
					}
				},
				{
					key: "specification",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "規格"),
							h("div", null, "Specification")
						]);
					}
				},
				{
					key: "original_price",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "零售價"),
							h("div", null, "Retail Price")
						]);
					}
				},
				{
					key: "price",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "優惠顧客價"),
							h("div", null, "PC Price")
						]);
					}
				},
				{
					key: "pv",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "點數"),
							h("div", null, "Points")
						]);
					}
				}
			]
		};
	},
	created() {
		this.$nextTick(function() {
			this.initData();
		});
	},
	destroyed() {
		this.showParent(true);
		//window.removeEventListener("scroll", this.handleScroll);
	},

	mounted() {
		this.$nextTick(function() {
			this.offsetTop=document.querySelector('.header').offsetHeight;
			if(this.$refs.root2&&this.$refs.root2.style){
				this.$refs.root2.style.minHeight =
				document.documentElement.clientHeight + "px";
			}
			this.showParent(false);
		});
	},
	watch: {
		shopCart: function(value) {
			if (value) {
				let model = value.filter(
					u => u.sku == this.$route.query.sku && u.num > 0
				)[0];
				if (model) {
					this.product.num = model.num;
				} else {
					this.product.num = 0;
				}
				this.$forceUpdate();
			}
		},
		showActivities:function(value){
			if(!value){
				this.showVideoUrl=null;
			}
		},
		'$route'(to, from) {   
            if(to.query&&to.query.sku!=this.product.sku){
				this.$refs.root2.scrollToTop();
				this.sleep(500).then(()=>{
					this.initData()
				})
				
			}  
        }
	},
	mixins: [userInfoOrderMethods, cartInfoMethods],
	components: {
		loading,
		buyCart,
		ProductCell,
		Video
	},
	computed: {
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			forCustomer: state => state.order.forCustomer,
			cartInfo: state => state.order.cartInfo
		}),
		isdescription: function() {
			return this.description.length > 0;
		},
		isdetail_description: function() {
			return this.detail_description.length > 0;
		},
		goodsWidth(){
			if (document.body.clientWidth <= 768) {
				return 46 
			}
			return 18
		},
	},
	methods: {
		...mapActions([
			"getProductDetailAction",
			"getProductDetail1Action",
			"getProductRelatedAction"
		]),
		limit(product){
			console.log(product)
			// if (product == 5) {
			// 	return true;
			// }else{
			// 	return false;
			// }
		},

		showActivity(product) {
			return (
				product.is_hot == 1 ||
				product.is_new == 1 ||
				product.is_promotion == 1
			);
		},
		autoNo(item) {
			if (item.type == "video" && item.src.indexOf("dohwg.cn") == -1) {
				this.showActivities = true;
				this.showVideoUrl = item.src;
			}
		},
		showParent(result) {
			var dom = document.querySelector("div.m-search");
			if (result) {
				dom.style.display = "block";
			} else {
				dom.style.display = "none";
			}
		},
		handleScroll(scrollTop) {
			this.scrollTop = scrollTop;
		},
		back() {
			this.$router.go(-1);
		},
		async getheight(url){
			var img= await this.$loadImage(url);
			console.log('img---------',img)
			if(img){
				return img.height;
			}
		},
		async initData() {
			this.showLoading = true;
			let sku = this.$route.query.sku;
			let response = await this.getProductDetailAction(sku);
			let relatedList = [];
			if (response) {
				this.detail_description = response.detail_description;
				this.description = response.description;
				this.image_path = response.image_path_big;

				var relatedRes = await this.getProductRelatedAction(sku);
				if (relatedRes && relatedRes[0]) {
					relatedList = relatedRes;
					// relatedRes.forEach((item, index) => {
					// 	var newitem = products[item.RightSKU];
					// 	if (newitem) {
					// 		related.push(newitem);
					// 	}
					// });
				}
				let response1 = await this.getProductDetail1Action({
					sku,
					it: 1
				});
				if (response1) {
					let newmodel = [];
					response1.forEach((item, index) => {
						if (item.url.indexOf("Video") == 0) {
						    //this.getheight().then((hegiht)=>{})
						    let src = item.url.split("=")[1]
						    if (src.indexOf('http') != 0) {
						    	src = `https://player.youku.com/embed/${src}?autoplay=false`
						    }
							newmodel.push({
								type: "video",
								icon: item.icon,
								src 
							});
						} else {
							newmodel.push({
								type: "img",
								icon: item.icon,
								src: item.url
							});
						}
					});
					
					this.imageList = newmodel;
				
				}
				if (!this.imageList[0]) {
					this.imageList.push({
						type: "img",
						icon: response.image_path_big,
						src: response.image_path_big
					});
				}
			}
			this.relatedList = [];
			this.$parent.menuList.forEach(item => {
				item.products.forEach(product => {
					if (product.sku == sku) {
						this.product = product;
						this.productType = item.name + ` (${item.name_en})`;
					}
					if (relatedList && relatedList[0]) {
						var model = relatedList.filter(
							u => u.RightSKU == product.sku
						)[0];
						if (model) {
							this.relatedList.push(product);
						}
					}
				});
			});
			console.log('this.product',this.product)
			this.shopCart.forEach(item => {
				if (item.sku == this.product.sku && item.num > 0) {
					this.product.num = item.num;
				}
			});
			if (!this.product.num) this.product.num = 0;
			this.PriceList=[];
			this.PriceList.push({
				sku: this.product.sku,
				specification:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].specification,
				original_price:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].original_price,
				price:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].price,
				pv:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].pv
			});
			this.showLoading = false;
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.root {
	background-color: white;
	z-index: 88;
}
.root2 {
	display: flex;
	position: absolute;
	flex-direction: column;
	width: 100%;
	//height: 100%;
	//min-height: 500px;
	z-index: 88;
	//background-color: white;
	background-color: white;
	position: absolute;
}
.load {
	height: 300px;
	position: relative;
}
.detailPage {
	// width: 1104px;
	// margin: auto;
	width: 78.03vw;
	margin: 40px auto;
	margin-top: 0;
}
.breadcrumbPage {
	background-color: #f5f5f5;
	line-height: 30px;
	overflow: hidden;
}
.root2 .breadcrumb {
	margin: auto;
}
.breadcrumb {
	width: 78.03vw;
	@include fontSize($font-size-20);
	background-color: #f5f5f5;
	padding: 0.1rem;
	color: $theme-color;
}
.product {
	width: 78.03vw;
	//max-width: 1090px;
	margin: auto;
	margin-top: 25px;
}
.show_nostock {
	font-weight: bold;
	@include fontSize($font-size-15);
	display: inline-block;
	line-height: 24px;
	padding: 5px 8px;
	background-color: #ccc;
	color: white;
	// border-radius: 5px;
	margin-top: 10px;
}
.img-responsive {
	display: block;
	max-width: 100%;
	height: auto;
}

.short-description {
	margin-bottom: 20px;
	clear: both;
	color: #868686;
	font-size: 16px;
	margin-top: 5px;
}
.stepper {
	margin-top: 20px;
}
.right {
	padding-left: 0.4rem;
	margin-bottom: 1rem;
}
.pro-name {
	font-size: 32px;
	color: $theme-color;
}
.sku {
	@include fontSize($font-size-14);
	margin-top: 10px;
	padding-left: 2px;
}
.info {
	padding-left: 2px;
	margin-top: 10px;
	span {
		// color:rgba(158, 158, 158, 0.91);
	}
	.info-ge {
		margin-left: 10px;
	}
	.info-pt {
		margin-left: 10px;
	}
}
.price {
	font-size: 36px;
	color: $theme-color;
}
.activityflag {
	padding-top: 18px;
	span {
		display: inline-block;
		// float: right;
		// width: 36px;
		// height: 18px;
		// line-height: 18px;
		margin-left: 4px;
		@include fontSize($font-size-14);
		color: #fff;
		text-align: center;
		padding: 2px 4px;
	}
	span:first-child {
		margin-left: 0;
	}
	.hot {
		background-color: $theme-color;
	}
}
.buy {
	margin-top: 0.5rem;
	background-color: $theme-color;
	border-color: $theme-color;
}
.intro-title {
	line-height: 3;
	//border-bottom: 1px solid rgba(158, 158, 158, 0.5);
	@include fontSize($font-size-16);
	color: $theme-color;
}
.detail {
	@include fontSize($font-size-16);
	margin: auto;
	margin-top: 10px;
}
.submit {
	margin-top: 10px;
}
.breadcrumb {
	margin: 0.1rem 0;
	@include fontSize($font-size-16);
	background-color: #f5f5f5;
	padding: 0.1rem;
	color: $theme-color;
}
.y_mobile {
	display: none;
}
.detail-link {
	font-weight: 500;
	color: $theme-color;
}
.fordetail {
	width: 47vw;
	margin: auto;
	
}


.carousellayou {
	position: relative;
	//height: 00px;
	width: 85%;
	margin: auto;
	.video {
		width: 100%;
		height:100%;
	}
	.product_img {
		width: 100%;
	}
	overflow: hidden;
}
.videoMask {
	cursor: pointer;
	//background-color:#2626264d;
	//  background-color:black;
	//  opacity: 0.5;
	//height: 100%;
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	text-align: center;
	img {
		width: 60px;
		//padding-top: 30%;
		position: absolute;
		top: 40%;
		left: 45%;
		margin: auto auto;
	}
	// position:absolute;
}
.m-result {
	overflow: hidden;
	ul {
		list-style: none;
	}
}

@media (max-width: 768px){
	.container {
		width: inherit;
		margin-top: 70px;
		width: 95%;
	}
	.no_mobile {
		display: none;
	}
	.y_mobile {
		display: block;
	}
	.right {
		padding: 0;
	}
	.pro-name {
		font-size: 0.8rem;
	}

.detailPage{
	width: 95%;
	margin: 20px auto;
}
.product{
	width: 100%;

}
div.carousellayou{
	width: 100%;
}
div.breadcrumb{
	font-size: 0.6rem;
	width: 95.00vw;
}
.sku{
	font-size: 0.7rem;
}
.info{
	font-size: 0.7rem;
}
.price{
	font-size: 1.5rem;
}
.short-description{
	font-size: 0.6rem;
	line-height: 20px;
}
.intro-title{
	font-size: 0.8rem;
}
.detail{
	margin-top: 0px;
	font-size: 0.6rem;
    line-height: 30px;
    text-align: center;
}
.fordetail{
	width: 100%;
	overflow: hidden;
}
}
</style>